import store from '../store/store';
import { action, select } from 'satcheljs/lib/legacy';
export default select({
    optionState: function () { return store; },
})(action('selectPopShowOption')(function selectPopShowOption(popEnabled, state) {
    var optionState = state.optionState;
    optionState.popEnabled = popEnabled;
}));
//# sourceMappingURL=selectPopShowOption.js.map